module.exports = __webpack_public_path__ + "img/shot_bigtx112004.08019d7a.png";